<div class="modal-header">
  <h4 class="modal-title pull-left">{{'MINE_TRACKER.API_KEY_CREATED' | translate}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="close()" title="{{'GLOBAL.FERMER' | translate}}">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="modal-content">
    
    <div class="alert alert-warning" role="alert">
      <i class="fas fa-exclamation-triangle"></i>
      <strong>{{'MINE_TRACKER.WARNING_TITLE' | translate}}</strong>
      <p>{{'MINE_TRACKER.WARNING' | translate}}</p>
    </div>

    <div class="api-key-section">
      <h5>{{'MINE_TRACKER.API_KEY' | translate}}</h5>
      <div class="input-group mb-3">
        <input 
          type="text" 
          class="form-control api-key-input" 
          [value]="createdApiKey.apiKey" 
          readonly>
        <div class="input-group-append">
          <button 
            class="btn btn-outline-primary" 
            type="button" 
            (click)="copyApiKey()"
            [disabled]="copied()">
            <i class="fas" [ngClass]="copied() ? 'fa-check' : 'fa-copy'"></i>
            {{ (copied() ? 'MINE_TRACKER.COPIED' : 'MINE_TRACKER.COPY') | translate }}
          </button>
        </div>
      </div>
    </div>

    <div class="details-section">
      <h5>{{'MINE_TRACKER.DETAILS' | translate}}</h5>
      <table class="table table-sm">
        <tbody>
          <tr>
            <th>{{'MINE_TRACKER.NAME' | translate}}:</th>
            <td>{{ createdApiKey.name }}</td>
          </tr>
          <tr>
            <th>{{'MINE_TRACKER.KEY_PREFIX' | translate}}:</th>
            <td>{{ createdApiKey.keyPrefix }}</td>
          </tr>
          <tr>
            <th>{{'MINE_TRACKER.CREATED_AT' | translate}}:</th>
            <td>{{ createdApiKey.createdAt | date:'short' }}</td>
          </tr>
          @if (createdApiKey.expiresAt) {
            <tr>
              <th>{{'MINE_TRACKER.EXPIRES_AT' | translate}}:</th>
              <td>{{ createdApiKey.expiresAt | date:'short' }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="close()">
    {{'GLOBAL.FERMER' | translate}}
  </button>
</div>
